import { useEffect, useState } from 'react';
import { IFeatClass } from '@pvplevelup/core/dist/feats/FeatTypes';

// the feat trees are a few hundred KB, so they load (once) only when something shows feats
let cache: IFeatClass[] | null = null;
let loading: Promise<IFeatClass[]> | null = null;

const load = () => loading = loading || import('@pvplevelup/core/dist/feats/data').then((m) => cache = m.FEAT_CLASSES);

/** all classes' feat trees; null while they load */
export const useFeatClasses = (): IFeatClass[] | null => {
  const [classes, setClasses] = useState<IFeatClass[] | null>(cache);
  useEffect(() => {
    let live = true;
    if(!cache)
      load().then((c) => { if(live) setClasses(c); });
    return () => { live = false; };
  }, []);
  return classes;
};
